<template>
    <div class="topic-of-interest-home-map">
        <property-search
            :landing-page="landingPage"
            :filterable="false"
            :toggleable="true"
        />
    </div>
</template>

<script>
    import "./TopicOfInterestHomeMap.scss";
    import {mapGetters} from "vuex";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";

    const PropertySearch = () => import("../../../../../PropertySearch/PropertySearch");

    export default {
        name: "TopicOfInterestHomeMap",
        components: {PropertySearch},

        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
        },

        computed: {
            ...mapGetters([
                'getDefaultMapCoordinates',
                'getCurrentProjectMlsId',
            ]),

            defaultLocation() {
                return (this.getDefaultMapCoordinates || '').split('|').map((number) => parseFloat(number));
            },
        }
    };
</script>
